import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import ExcelJS from 'exceljs';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import { calculateAverageHoursOfArray, calculateAverageOfArray, calculateFirstQuartile, calculateMaxOfArray, calculateMedian, calculateMinOfArray, calculateStandardDeviation, calculateThirdQuartile } from '../../utils/utils';
import Select, { SelectItemRenderer } from 'react-dropdown-select';

import UserName from '../common/user/UserName';
import { statusEnum, TourHeader, visitorHeader } from '../../constants/constants';
import { getStateLandmark, getUnits } from '../../redux/landmark/actions/landmark.action';
import { getMetrics } from '../../redux/metrics/actions/metrics.actions';
import { AppDispatch, IRootState } from '../../redux/rootReducer';
import { getLocation } from '../../redux/location/actions/location.action';

import { Location, ManagementCompany, MetricsData, MetricsExcelData, Status, visitorObj } from '../visitor/interface/Visitor.interface';
import { ClickEventProps, Events, LocationData, UnitDetails } from './metrics.interface';

import Loader from '../common/loader/Loader';
import SearchIcon from '../../images/search-dark-version.svg';
import CalendarIcon from '../../images/calendar-icon.svg';

import 'react-datepicker/dist/react-datepicker.css';
import styles from './metrics.module.css';
import CustModal from '../common/custmodal/CustModal';
import CloseIcon from '../svgIcons/CloseIcon';
import PhoneInput from 'react-phone-input-2';
import DownloadIcon from '../svgIcons/DownloadIcon';
import { hasPermission } from '../auth/login/Login';

const tableHeader = [
	{ title: 'Visitor Email' },
	{ title: 'Property Name' },
	{ title: 'Unit Name' },
	{ title: 'Management Company' },
	{ title: 'Locker' },
	{ title: 'Account Creation Day/Time' },
	{ title: 'Appointment Booking Day/time' },
	{ title: 'Appointment Day/Time' },
	{ title: 'Appointment Cancellation Day/time' },
	{ title: 'Appointment Rescheduled Day/time' },
	{ title: 'Tour Duration' },
	{ title: 'Relative Tour Start' },
	{ title: 'Relative Tour End' },
	{ title: "Visitor clicked\n'Apply Now'" }
]



const metrics = () => {
	const dispatch = useDispatch<AppDispatch>();
	const [startDate, setStartDate] = useState<Date | null>()
	const [endDate, setEndDate] = useState<Date | null>()
	const [locations, setLocations] = useState<Location[]>([]);
	const [states, setStates] = useState<Location[]>([]);
	const [cities, setCities] = useState<Location[]>([]);

	const permissionLoading = useSelector((state: IRootState) => state?.permissionsReducer?.loading);
	const canReadMetrics = hasPermission("Metrics", "Metric", "read");

	const [managementCompanies, setManagementCompanies] = useState<ManagementCompany[]>([])
	const adminLocations = useSelector((state: IRootState) => state.locationReducer.data);
	const adminLoading = useSelector((state: IRootState) => state.locationReducer.loading)
	const metricsData = useSelector((state: IRootState) => state.metricsReducer.data)
	const metricsLoading = useSelector((state: IRootState) => state.metricsReducer.loading)

	const stateCollection = useSelector((state: IRootState) => state.landmarkReducer.data);
	const locationLoading = useSelector((state: IRootState) => state.landmarkReducer.loading);
	const landMarkData = useSelector((state: IRootState) => state.landmarkReducer.locationUnits?.data);
	const landMarkLoading = useSelector((state: IRootState) => state.landmarkReducer.loading);

	const [totalIdleProperties, setTotalIdleProperties] = useState<number>(0);
	const [totalAvailableProperties, setTotalAvailableProperties] = useState<number>(0)

	const [selectAllProperties, setSelectAllProperties] = useState<boolean>(false)
	const [selectedLocations, setSelectedLocations] = useState<Location[]>([])
	const [resultProperties, setResultProperties] = useState<string[]>([])
	const [clickEventData, setClickEventData] = useState<ClickEventProps>({})

	const [selectedState, setSelectedState] = useState<Location[]>([])
	const [selectedCities, setSelectedCities] = useState<Location[]>([])
	const [selectAllCities, setSelectAllCities] = useState<boolean>(false)

	// management company
	const [selectAllManagementCompanies, setSelectAllManagementCompanies] = useState<boolean>(true)
	const [selectedCompanies, setSelectedCompanies] = useState<ManagementCompany[]>([])

	// Status Enum
	const [selectedStatus, setSelectedStatus] = useState<Status[]>([])
	const [selectAllStatus, setSelectAllStatus] = useState<boolean>(false)

	const [showAllPropertyMetrics, setShowAllPropertyMetrics] = useState<boolean>(false)
	const [applicationEventData, setApplicationEventDate] = useState<Events[]>([])
	const [leaseEventData, setLeaseEventData] = useState<Events[]>([]);

	const [showModalPopup, setShowModalPopup] = useState<boolean>(false)
	const [selectedEvent, setSelectedEvent] = useState<string>('');

	const [showCommonModalPopup, setShowCommonModalPopup] = useState<string | null>(null);

	type HeaderItem = { [key: string]: string };
	const CustomModalHeader: HeaderItem[] = [
		{ 'uniqueVisitorsRecords': 'Unique Visitors' },
		{ 'totalAccountsRecords': 'Accounts created' },
		{ 'toursRecords': 'Tours' },
		{ 'applyClickedRecords': 'Apply Now Clicked During Tour' },
		{ 'appointmentCanacellationRecords': 'Cancelled Appointments' },
		{ 'appointmentRescheduleRecords': 'Reschedule Appointments' },
		{ 'appointmentWithNoTours': 'No Tour Appointments' },
		{ 'data': 'Appointments' },
		{ 'toursOutsideOfficeHoursRecords': 'Tours After The Business Hours' }
	]

	function getHeaderValue(key: string): string | undefined {
		const result: HeaderItem | undefined = CustomModalHeader.find((item) => key in item);
		return result ? result[key] : undefined;
	}

	useEffect(() => {
		dispatch(getLocation(undefined, undefined, true));
		dispatch(getStateLandmark());
	}, []);

	useEffect(() => {
		if (!Object.keys(selectedState).length && stateCollection && Object.keys(stateCollection).length && stateCollection.states && stateCollection.states.length) {
			setStates(stateCollection.states.map((item: string) => ({ id: item, label: item, value: item } as Location)));
		}

		if (Object.keys(selectedState).length && !Object.keys(selectedCities).length && stateCollection && Object.keys(stateCollection).length && stateCollection.cities && stateCollection.cities.length) {
			setCities(stateCollection.cities.map((item: string) => ({ id: item, label: item, value: item } as Location)));
		}

		if (Object.keys(selectedCities).length && stateCollection && Object.keys(stateCollection).length && stateCollection.locationNames && stateCollection.locationNames.length) {
			setLocations(stateCollection.locationNames.map((item: { locationId: string, locationName: string }) => ({ id: item.locationId, label: item.locationName, value: item.locationId } as Location)));
		}
	}, [stateCollection])

	useEffect(() => {
		const clickEvent: ClickEventProps = {};
		if (metricsData?.getLinkClickCount?.length) {

			metricsData?.getLinkClickCount.forEach((item: { lch_linkType: string, linkTypeCount: string }) => {
				clickEvent[item.lch_linkType as keyof ClickEventProps] = item.linkTypeCount;
			});
		}

		if (metricsData?.userEvents?.length) {
			const applicationEvents: Events[] = [];
			const leaseEvents: Events[] = [];
			metricsData?.userEvents.forEach((event: Events) => {
				if (event?.applicationEventDate?.length && (
					moment(moment(event?.applicationEventDate, 'MM-DD-YYYY').format('MM-DD-YYYY')).isSameOrAfter((moment(startDate, 'MM-DD-YYYY').format('MM-DD-YYYY'))) &&
					moment(moment(event?.applicationEventDate, 'MM-DD-YYYY').format('MM-DD-YYYY')).isSameOrBefore((moment(endDate, 'MM-DD-YYYY').format('MM-DD-YYYY')))
				)) {
					applicationEvents.push(event)
				}
				if (event?.leaseSignEventDate?.length && (
					moment(moment(event?.leaseSignEventDate, 'MM-DD-YYYY').format('MM-DD-YYYY')).isSameOrAfter((moment(startDate).format('MM-DD-YYYY'))) &&
					moment(moment(event?.leaseSignEventDate, 'MM-DD-YYYY').format('MM-DD-YYYY')).isSameOrBefore((moment(endDate).format('MM-DD-YYYY')))
				)) {
					leaseEvents.push(event)
				}
			})

			setLeaseEventData(leaseEvents);
			setApplicationEventDate(applicationEvents)
		} else {
			setLeaseEventData([]);
			setApplicationEventDate([])
		}

		setClickEventData(clickEvent)
	}, [metricsData])

	useEffect(() => {
		setSelectAllStatus(true)
		setSelectedStatus(statusEnum)
	}, [adminLocations]);

	useEffect(() => {
		if (landMarkData) {
			let idleUnits = 0;
			let availableUnits = 0;

			landMarkData?.forEach((element: LocationData) => {
				element?.unitDetails?.forEach((unit: UnitDetails) => {
					if (unit.availability === null) {
						idleUnits++;
					} else {
						availableUnits++;
					}
				})
			});

			setTotalAvailableProperties(availableUnits);
			setTotalIdleProperties(idleUnits)
		} else {
			setTotalAvailableProperties(0);
			setTotalIdleProperties(0)
		}
	}, [landMarkData])


	const getMetricsData = async () => {
		if (selectedCompanies?.length && !selectedState?.length) {
			const selectedLocationIds: string[] = [];
			const selectedLocationNames: string[] = [];
			const selectedStatusNames: string[] = [];
			const selectedManagementCompanies: string[] = [];

			selectedStatus.forEach((el: Status) => {
				selectedStatusNames.push(el.label)
			});

			await selectedCompanies.forEach((el: ManagementCompany) => {
				selectedManagementCompanies.push(el.label)
			});

			stateCollection?.allLocations?.forEach((location: { id: string, managementCompany: string, locationName: string }) => {
				if (selectedManagementCompanies?.includes(location?.managementCompany)) {
					selectedLocationIds.push(location.id);
					selectedLocationNames.push(location.locationName)
				}
			})

			if (endDate && startDate && selectedLocationIds?.length) {

				dispatch(getMetrics({ locationId: selectedLocationIds, endDateTime: moment(endDate).format('YYYY-MM-DD'), startDateTime: moment(startDate).format('YYYY-MM-DD'), propertyStatus: selectedStatusNames?.length ? selectedStatusNames : [''], managementCompany: showAllPropertyMetrics ? [''] : selectedManagementCompanies?.length ? selectedManagementCompanies : [''] }))
				setResultProperties(selectedLocationNames)
			}
		} else {
			const selectedLocationIds: string[] = [];

			const selectedLocationNames: string[] = [];
			const selectedStatusNames: string[] = [];
			const selectedManagementCompanies: string[] = [];
			const checkAvailabilityByLocationId: string[] = [];

			selectedLocations.forEach((el: Location) => {
				selectedLocationIds.push(el.id);
				selectedLocationNames.push(el.label)
			});

			selectedStatus.forEach((el: Status) => {
				selectedStatusNames.push(el.label)
			});

			selectedCompanies.forEach((el: ManagementCompany) => {
				selectedManagementCompanies.push(el.label)
			});

			if (showAllPropertyMetrics) {
				[...adminLocations.locations, ...adminLocations.locationinvitedlist].forEach((property: { id: string, propertyStatus: string }) => {
					if (selectedStatusNames.includes(property.propertyStatus) && selectedLocationIds.includes(property?.id)) {
						checkAvailabilityByLocationId.push(property?.id)
					}
				})
			} else {
				if (selectedManagementCompanies.length && selectedStatusNames?.length) {
					[...adminLocations.locations, ...adminLocations.locationinvitedlist].forEach((property: { managementCompany: string, id: string, propertyStatus: string }) => {
						if (selectedManagementCompanies.includes(property?.managementCompany?.toLowerCase()) && selectedStatusNames.includes(property?.propertyStatus) && selectedLocationIds.includes(property?.id)) {
							checkAvailabilityByLocationId.push(property?.id);
						}
					})
				} else if (!selectedManagementCompanies.length && selectedStatusNames?.length) {
					[...adminLocations.locations, ...adminLocations.locationinvitedlist].forEach((property: { propertyStatus: string, id: string }) => {
						if (selectedStatusNames.includes(property.propertyStatus) && selectedLocationIds.includes(property?.id)) {
							checkAvailabilityByLocationId.push(property?.id)
						}
					})
				} else if (!selectedManagementCompanies.length && !selectedStatusNames?.length) {
					[...adminLocations.locations, ...adminLocations.locationinvitedlist].forEach((property: { id: string }) => {
						if (selectedLocationIds.includes(property?.id)) {
							checkAvailabilityByLocationId.push(property?.id)
						}
					})
				} else if (selectedManagementCompanies.length && !selectedStatusNames?.length) {
					[...adminLocations.locations, ...adminLocations.locationinvitedlist].forEach((property: { managementCompany: string, id: string }) => {
						if (selectedManagementCompanies.includes(property?.managementCompany?.toLowerCase()) && selectedLocationIds.includes(property?.id)) {
							checkAvailabilityByLocationId.push(property?.id)
						}
					})
				}
			}

			if (checkAvailabilityByLocationId?.length) {
				dispatch(
					getUnits({
						locationIds: checkAvailabilityByLocationId,
						startDateTime: moment(startDate).format('YYYY-MM-DD'),
						endDateTime: moment(endDate).format('YYYY-MM-DD'),
					}),
				);
			} else {
				setTotalAvailableProperties(0)
				setTotalIdleProperties(0)
			}

			if (endDate && startDate && selectedLocationIds?.length) {
				dispatch(getMetrics({ locationId: selectedLocationIds, endDateTime: moment(endDate).format('YYYY-MM-DD'), startDateTime: moment(startDate).format('YYYY-MM-DD'), propertyStatus: selectedStatusNames?.length ? selectedStatusNames : [''], managementCompany: showAllPropertyMetrics ? [''] : selectedManagementCompanies?.length ? selectedManagementCompanies : [''] }))
				setResultProperties(selectedLocationNames)
			}
		}
	}

	const itemRenderer = (props: SelectItemRenderer<Location>) => {
		const { item } = props;
		return (<div className={styles.boxes}>
			<input type="checkbox" id={item?.id} />
			<label htmlFor={item?.id}>{item?.value}</label>
		</div>
		);
	};

	const statusRenderer = (props: SelectItemRenderer<Status>) => {
		const { item } = props;
		return (<div className={styles.boxes}>
			<input type="checkbox" id={item?.label} />
			<label htmlFor={item?.label}>{item?.value}</label>
		</div>);
	};


	const customDropdownRenderer = ({ props, state, methods }: any) => {
		const regexp = new RegExp(state.search, 'i');

		if (state?.values?.length !== state?.searchResults?.length) {
			setSelectAllProperties(false)
		}
		if (state?.values?.length === state?.searchResults?.length) {
			setSelectAllProperties(true)
		}

		return (
			<div className={styles.customDropdownMenu}>
				{!locationLoading && locations?.length ? <div className={styles.inlineItems}>
					<div className={styles.boxes} >
						<input type="checkbox" id='selectAll' checked={selectAllProperties} onChange={(e) => {
							setSelectAllProperties(e?.target?.checked)
							e?.target?.checked ? methods?.selectAll() : methods?.clearAll()
						}} />
						<label htmlFor='selectAll'>Select All</label>
					</div>
					<button className={styles.clearBtn} onClick={() => methods?.clearAll()} >
						Clear All
					</button>
				</div>
					: locationLoading ?
						<div className={styles.noData}>Loading</div>
						:
						<div className={styles.noData}>No Data Found</div>
				}
				<div className={styles.listContainer}>
					{props.options
						.filter((item: any) => regexp.test(item[props.searchBy] || item[props.labelField]))
						.map((option: any) => {
							if (!props.keepSelectedInList && methods.isSelected(option)) {
								return null;
							}

							return (
								<div
									key={option[props.valueField]}
									className={styles.boxes}
								>
									<input
										type="checkbox"
										id={option[props.labelField]}
										onChange={() => (option.disabled ? undefined : methods.addItem(option))}
										checked={state.values.indexOf(option) !== -1}
									/>
									<label htmlFor={option[props.labelField]}>{option[props.labelField]}</label>
								</div>
							);
						})}
				</div>
			</div >
		);
	};

	const customStatusDropdownRenderer = ({ props, state, methods }: any) => {
		const regexp = new RegExp(state.search, 'i');

		if (state?.values?.length !== state?.searchResults?.length) {
			setSelectAllStatus(false)
		}
		if (state?.values?.length === state?.searchResults?.length) {
			setSelectAllStatus(true)
		}

		return (
			<div className={styles.customDropdownMenu}>
				<div className={styles.inlineItems}>
					<div className={styles.boxes} >
						<input type="checkbox" id='selectAll' checked={selectAllStatus} onChange={(e) => {
							setSelectAllStatus(e?.target?.checked)
							e?.target?.checked ? methods?.selectAll() : methods?.clearAll()
						}} />
						<label htmlFor='selectAll'>Select All</label>
					</div>
					<button className={styles.clearBtn} onClick={() => methods?.clearAll()} >
						Clear All
					</button>
				</div>
				<div className={styles.listContainer}>
					{props.options
						.filter((item: any) => regexp.test(item[props.searchBy] || item[props.labelField]))
						.map((option: any) => {
							if (!props.keepSelectedInList && methods.isSelected(option)) {
								return null;
							}

							return (
								<div
									key={option[props.valueField]}
									className={styles.boxes}
								>
									<input
										type="checkbox"
										id={option[props.labelField]}
										onChange={() => (option.disabled ? undefined : methods.addItem(option))}
										checked={state.values.indexOf(option) !== -1}
									/>
									<label htmlFor={option[props.labelField]}>{option[props.labelField]}</label>
								</div>
							);
						})}
				</div>
			</div >
		);
	}

	const customCompanyDropdownRenderer = ({ props, state, methods }: any) => {
		const regexp = new RegExp(state.search, 'i');

		if (state?.values?.length !== state?.searchResults?.length) {
			setSelectAllManagementCompanies(false)
		}
		if (state?.values?.length === state?.searchResults?.length) {
			setSelectAllManagementCompanies(true)
		}

		return (
			<div className={styles.customDropdownMenu}>
				{!adminLoading && managementCompanies?.length ? <div className={styles.inlineItems}>
					<div className={styles.boxes} >
						<input type="checkbox" id='selectAll' checked={selectAllManagementCompanies} onChange={(e) => {
							setSelectAllManagementCompanies(e?.target?.checked)
							e?.target?.checked ? methods?.selectAll() : methods?.clearAll()
						}} />
						<label htmlFor='selectAll'>Select All</label>
					</div>
					<button className={styles.clearBtn} onClick={() => methods?.clearAll()} >
						Clear All
					</button>
				</div>
					: adminLoading ?
						<div className={styles.noData}>Loading</div>
						:
						<div className={styles.noData}>No Data Found</div>
				}
				<div className={styles.listContainer}>
					{props.options.map((option: any) => {
						if (!props.keepSelectedInList && methods.isSelected(option)) {
							return null;
						}

						return (
							<div
								key={option[props.valueField]}
								className={styles.boxes}
							>
								<input
									type="checkbox"
									id={option[props.labelField]}
									onChange={() => (option.disabled ? undefined : methods.addItem(option))}
									checked={methods.isSelected(option)}
								/>
								<label htmlFor={option[props.labelField]}>{option[props.labelField]}</label>
							</div>
						);
					})}
				</div>
			</div >
		);
	};

	const customStateDropdownRenderer = ({ props, state, methods }: any) => {
		return (
			<div className={styles.customDropdownMenu}>
				{!adminLoading && states?.length ? ""
					: adminLoading ?
						<div className={styles.noData}>Loading</div>
						:
						<div className={styles.noData}>No Data Found</div>
				}
				<div className={styles.listContainer}>
					{props.options.map((option: any) => {
						if (!props.keepSelectedInList && methods.isSelected(option)) {
							return null;
						}

						return (
							<div
								key={option[props.valueField]}
								className={styles.boxes}
							>
								<input
									type="radio"
									id={option[props.labelField]}
									onChange={() => (option.disabled ? undefined : methods.addItem(option))}
									checked={methods.isSelected(option)}
								/>
								<label htmlFor={option[props.labelField]}>{option[props.labelField]}</label>
							</div>
						);
					})}
				</div>
			</div >
		);
	};

	const customCityDropdownRenderer = ({ props, state, methods }: any) => {

		if (state?.values?.length !== state?.searchResults?.length) {
			setSelectAllCities(false)
		}
		if (state?.values?.length === state?.searchResults?.length) {
			setSelectAllCities(true)
		}

		const handleClearAll = () => {
			methods?.clearAll();
			setLocations([]);
			setSelectedLocations([]);
		};


		return (
			<div className={styles.customDropdownMenu}>
				{!locationLoading && cities?.length ? <div className={styles.inlineItems}>
					<div className={styles.boxes} >
						<input type="checkbox" id='selectAll' checked={selectAllCities} onChange={(e) => {
							setSelectAllCities(e?.target?.checked)
							e?.target?.checked ? methods?.selectAll() : handleClearAll()
						}} />
						<label htmlFor='selectAll'>Select All</label>
					</div>
					<button className={styles.clearBtn} onClick={handleClearAll} >
						Clear All
					</button>
				</div>
					: locationLoading ?
						<div className={styles.noData}>Loading</div>
						:
						<div className={styles.noData}>No Data Found</div>
				}
				<div className={styles.listContainer}>
					{props.options.map((option: any) => {
						if (!props.keepSelectedInList && methods.isSelected(option)) {
							return null;
						}

						return (
							<div
								key={option[props.valueField]}
								className={styles.boxes}
							>
								<input
									type="checkbox"
									id={option[props.labelField]}
									onChange={() => (option.disabled ? undefined : methods.addItem(option))}
									checked={methods.isSelected(option)}
								/>
								<label htmlFor={option[props.labelField]}>{option[props.labelField]}</label>
							</div>
						);
					})}
				</div>
			</div >
		);
	};

	const customContentRenderer = ({ props, state }: any) => (
		state.values?.length ?
			<div style={{ cursor: 'pointer' }}>
				{state.values.length} of {props.options.length} Properties selected
			</div>
			:
			<div className={styles.placeholder}><span>Properties</span></div>
	);

	const customStateContentRenderer = ({ props, state }: any) => (
		state.values?.length ?
			<div style={{ cursor: 'pointer' }}>
				{state.values[0].label}
			</div>
			:
			<div className={styles.placeholder}><span>State</span></div>
	);

	const customCityContentRenderer = ({ props, state }: any) => (
		state.values?.length ?
			<div style={{ cursor: 'pointer' }}>
				{state.values.length} of {props.options.length} Cities selected
			</div>
			:
			<div className={styles.placeholder}><span>City</span></div>
	);

	const customStatusContentRenderer = ({ props, state }: any) => (
		state.values?.length ?
			<div style={{ cursor: 'pointer' }}>
				{state.values.length} of {props.options.length} Status selected
			</div>
			:
			<div className={styles.placeholder}><span>Status</span></div>
	);

	const customManagementContentRenderer = ({ props, state }: any) => (
		state.values?.length ?
			<div style={{ cursor: 'pointer' }}>
				{state.values.length} of {props.options.length} Companies selected
			</div>
			:
			<div className={styles.placeholder}><span>Management Company</span></div>
	);

	const resetMetrics = async (e?: React.MouseEvent<HTMLButtonElement>) => {
		e?.preventDefault();
		setStartDate(null);
		setEndDate(null);
		setSelectedLocations([]);
		setResultProperties([]);
		setClickEventData({});
		setSelectedStatus(statusEnum);
		await setSelectedState([]);
		setSelectedCompanies([]);
		await setSelectedCities([]);
		setLocations([]);
		setCities([]);
		setShowAllPropertyMetrics(false);
		setTotalAvailableProperties(0);
		setTotalIdleProperties(0);
		await getDefaultManagementCompanies();
	};

	const handleChangeState = (values: Location[]) => {
		if (!showAllPropertyMetrics) {
			setSelectedState(values);
			setCities([])
			setSelectedCities([])
			setLocations([])
			setSelectedLocations([])
			setSelectedCompanies([])
			if (values && values.length > 0 && values[0].label) {
				getCityList(values[0].label);
			}
		}
	};

	const getCityList = (value: string) => {
		const cityList: Location[] = stateCollection?.allLocations
			.filter((item: any) => value === item?.state)
			.map((item: any) => ({ id: item.city, label: item.city, value: item.city }))

		setCities(() => {
			const uniqueCityList = cityList.filter((city, index, self) => self.findIndex(c => c.id === city.id && c.label === city.label) === index);
			return uniqueCityList;
		});
	}

	const handleChangeCities = (values: Location[]) => {

		if (selectedState?.length) {
			setManagementCompanies([]);
		}

		if (!showAllPropertyMetrics) {
			setSelectedCities(values);
			setSelectedLocations([]);
			setSelectedCompanies([]);
			const labels = values.map((item: Location) => item.label);

			const filteredLocations = stateCollection?.allLocations
				.filter((item: any) => selectedState[0]?.label === item?.state && labels.includes(item.city))
				.map((locationData: any) => ({
					id: locationData.id,
					label: locationData.locationName,
					value: locationData.id
				}));

			setLocations(filteredLocations || []);
		}
	};

	const handleChangeProperties = (values: Location[]) => {
		setSelectedLocations(values)
		const labels = values.map((item: Location) => item.label);

		if (!showAllPropertyMetrics) {
			setSelectedCompanies([]);

			const filteredCompanies = stateCollection?.allLocations
				?.filter((item: any) => selectedState[0]?.label === item?.state && labels?.includes(item?.locationName))
				?.map((locationData: any) => ({
					id: locationData?.id,
					label: locationData?.managementCompany?.toLowerCase(),
					value: locationData?.managementCompany?.toLowerCase()
				}));

			setManagementCompanies(() => {
				const uniqueManageMentCompanies = filteredCompanies
					?.filter((company: any, index: any, self: any) =>
						company?.id && company?.label &&
						self?.findIndex((c: { label: any; }) =>
							c?.label === company?.label) === index
					);
				return uniqueManageMentCompanies;
			})
		}
	}

	const getAllPropertyIds = () => {
		setSelectedState([])
		setSelectedCities([])
		setCities([])
		setSelectedLocations(adminLocations?.locations.length > 0 || adminLocations?.locationinvitedlist.length > 0 ? [...adminLocations.locations, ...adminLocations.locationinvitedlist] : [])
		setLocations(adminLocations?.locations.length > 0 || adminLocations?.locationinvitedlist.length > 0 ? [...adminLocations.locations, ...adminLocations.locationinvitedlist] : [])
		setSelectAllProperties(true)
	}

	const getAllManagementCompanies = async () => {
		const filteredCompanies = await [...adminLocations.locations, ...adminLocations.locationinvitedlist]?.map((locationData: any) => ({
			id: locationData?.id,
			label: locationData?.managementCompany?.toLowerCase(),
			value: locationData?.managementCompany?.toLowerCase()
		}));

		let uniqueManagementCompanies: ManagementCompany[] = []
		await setManagementCompanies(() => {
			uniqueManagementCompanies = filteredCompanies
				?.filter((company: any, index: any, self: any) =>
					company?.id && company?.label &&
					self?.findIndex((c: { label: any }) => c.label === company?.label) === index
				);
			return uniqueManagementCompanies;
		});

		await setSelectAllManagementCompanies(true)
		await setSelectedCompanies(uniqueManagementCompanies)
	}


	useEffect(() => {
		if (showAllPropertyMetrics && !adminLoading) {
			setResultProperties([])
			getAllPropertyIds()
			getAllManagementCompanies()
		} else {
			setSelectedLocations([])
			setSelectAllManagementCompanies(false)
			setSelectedCompanies([])
			setSelectedLocations([])
			setLocations([])
			setSelectAllProperties(false)
			setResultProperties([])
		}
	}, [showAllPropertyMetrics, adminLoading])


	const exportToExcel = () => {

		const data: MetricsExcelData[] = [];

		metricsData?.data?.map((item: MetricsData) => {
			const newDataItem: MetricsExcelData = {
				email: item.email,
				locationName: item.locationName,
				unitName: item.unitName,
				managementCompany: item.managementCompany || '',
				locker: item.locker,
				userCreationTime: (item?.userCreationTime) ? moment.utc(item?.userCreationTime).tz(item?.timeZone).locale('en').format('YYYY-MM-DD hh:mm A') : '',
				appointmentCreationTime: item.appointmentCreationTime ? moment(item.appointmentCreationTime, 'YYYY-MM-DD h:mm A').format('YYYY-MM-DD hh:mm A') : '-',
				reservedDate: (moment(`${item.reservedDate} ${item.start_time}`, 'YYYY-MM-DD h:mm A').format('YYYY-MM-DD h A') + ' - ' + moment(`${item.reservedDate} ${item.end_time}`, 'YYYY-MM-DD h:mm A').format('h A')),
				appointmentCancellationTime: item.appointmentCancellationTime ? moment(item.appointmentCancellationTime, 'YYYY-MM-DD h:mm A').format('YYYY-MM-DD hh:mm A') : '-',
				appointmentRescheduledTime: item.appointmentRescheduledTime ? moment(item.appointmentRescheduledTime, 'YYYY-MM-DD h:mm A').format('YYYY-MM-DD hh:mm A') : '-',
				formattedDuration: item?.formattedDuration || '-',
				relativeStartTime: item?.relativeStartTime || '-',
				relativeEndTime: item?.relativeEndTime || '-',
				isApplyClicked: item?.isApplyClicked ? 'Yes' : 'No',
			};
			data.push(newDataItem);
		});

		// Create a new workbook
		const workbook = new ExcelJS.Workbook();
		const worksheet = workbook.addWorksheet('Sheet1');

		// Define columns
		worksheet.columns = [
			{ header: 'Visitor Email', key: 'email', width: 40 },
			{ header: 'Property Name', key: 'locationName', width: 20 },
			{ header: 'Unit Name', key: 'unitName', width: 20 },
			{ header: 'Management Company', key: 'managementCompany', width: 20 },
			{ header: 'Locker', key: 'locker', width: 10 },
			{ header: 'Account Creation Day/Time', key: 'userCreationTime', width: 25 },
			{ header: 'Appointment Booking Day/time', key: 'appointmentCreationTime', width: 28 },
			{ header: 'Appointment Day/Time', key: 'reservedDate', width: 25 },
			{ header: 'Appointment Cancellation Day/time', key: 'appointmentCancellationTime', width: 32 },
			{ header: 'Appointment Rescheduled Day/time', key: 'appointmentRescheduledTime', width: 32 },
			{ header: 'Tour Duration', key: 'formattedDuration', width: 15 },
			{ header: 'Relative Tour Start', key: 'relativeStartTime', width: 20 },
			{ header: 'Relative Tour End', key: 'relativeEndTime', width: 20 },
			{ header: 'Visitor clicked "Apply Now"', key: 'isApplyClicked', width: 25 },
		];

		// Add data to the worksheet
		data.map((item: MetricsExcelData) => {
			worksheet.addRow(item);
		});

		worksheet.columns.forEach(column => {
			column.alignment = { horizontal: 'center' };
		});

		// Generate Excel file
		workbook.xlsx.writeBuffer().then((buffer) => {
			// Save the file
			const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
			const fileName = 'MetricsData.xlsx';
			const url = URL.createObjectURL(blob);
			const a = document.createElement('a');
			document.body.appendChild(a);
			a.href = url;
			a.download = fileName;
			a.click();
			window.URL.revokeObjectURL(url);
		});
	};

	useEffect(() => {
		return () => {
			resetMetrics()
		}
	}, []);


	const onCloseModal = () => {
		setSelectedEvent('')
	}

	const onCustomCloseModal = () => {
		setShowCommonModalPopup(null)
	}

	const getDefaultManagementCompanies = () => {
		const managementCompanies = new Set<string>();
		const uniqueCompanies: ManagementCompany[] = [];

		stateCollection.allLocations?.forEach((location: { managementCompany: string }) => {
			const company = location?.managementCompany?.trim();
			if (company && !managementCompanies.has(company)) {
				managementCompanies.add(company);
				uniqueCompanies.push({
					id: company,
					label: company,
					value: company
				});
			}
		});
		setManagementCompanies(uniqueCompanies);
	}

	useEffect(() => {
		if (selectedState?.length === 0) {
			getDefaultManagementCompanies();
		} else {
			setManagementCompanies([]);
		}
	}, [selectedState, stateCollection])

	const onDownloadIcon = () => {
		// Create a new workbook
		const workbook = new ExcelJS.Workbook();
		const worksheet = workbook.addWorksheet(`${selectedEvent}-${moment(startDate).format('MM-DD-YYYY')}-${moment(endDate).format('MM-DD-YYYY')}`);

		worksheet.columns = [
			{ header: 'First Name', key: 'firstName', width: 20 },
			{ header: 'Last Name', key: 'lastName', width: 20 },
			{ header: 'Email', key: 'email', width: 40 },
			{ header: 'Phone No.', key: 'phoneNumber', width: 25 },
			{ header: 'Location Name', key: 'locationName', width: 28 },
			{ header: 'expectedMoveInDate', key: 'expectedMoveInDate', width: 32 },
			{ header: 'Desired Bedrooms', key: 'desiredNumBedrooms', width: 32 },
			{ header: 'Application Event Date', key: 'applicationEventDate', width: 15 },
			{ header: 'Lease Sign Event Date', key: 'leaseSignEventDate', width: 20 },
			{ header: 'Appointment', key: 'hasAppointment', width: 20 }
		];

		// Add data to the worksheet
		const eventData = selectedEvent === 'application' ? applicationEventData : leaseEventData;

		eventData.forEach((item: Events) => {
			worksheet.addRow({
				firstName: item.firstName,
				lastName: item.lastName,
				email: item.email,
				phoneNumber: item.phoneNumber,
				locationName: item.locationName,
				expectedMoveInDate: item.expectedMoveInDate,
				desiredNumBedrooms: item.desiredNumBedrooms,
				applicationEventDate: item.applicationEventDate,
				leaseSignEventDate: item.leaseSignEventDate,
				hasAppointment: item.hasAppointment === '1' ? 'Yes' : 'No' // Ensure boolean conversion
			});
		});

		worksheet.columns.forEach(column => {
			column.alignment = { horizontal: 'center' };
		});

		// Generate Excel file
		workbook.xlsx.writeBuffer().then((buffer) => {
			// Save the file
			const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
			const fileName = `${selectedEvent}-${moment(startDate).format('MM-DD-YYYY')} - ${moment(endDate).format('MM-DD-YYYY')}.xlsx`;
			const url = URL.createObjectURL(blob);
			const a = document.createElement('a');
			document.body.appendChild(a);
			a.href = url;
			a.download = fileName;
			a.click();
			window.URL.revokeObjectURL(url);
		});
	}

	const ModalContent = () => {
		return (
			<div className={styles.modalContentContainer}>
				<div className={styles.modalHeader}>
					<h3>{`${selectedEvent} Events`}</h3>

					<div className={styles.iconContainer} >
						<div className={styles.downloadIcon} onClick={onDownloadIcon}>
							<DownloadIcon color='#fff' width='16' height='16' />
						</div>
						<div className={styles.closeIcon} onClick={() => {
							setSelectedEvent('');
							setShowModalPopup(false);
						}}>
							<CloseIcon />
						</div>
					</div>
				</div>

				<div className={styles.modalBodyContainer}>
					<div className={`${styles.tableContainer} customScrollbar`}>
						<table className={`${styles.visitorTable} visitorListing`}>
							<thead>
								<tr>
									<th>No.</th>
									{visitorHeader.slice(0, 9).map((item, index) => {
										return <th key={index}>{item.title}</th>;
									})}
									<th>Appointment</th>
								</tr>
							</thead>
							<tbody>
								{selectedEvent === 'lease' ? leaseEventData && leaseEventData?.length && leaseEventData.map((item: any, index: number) => {
									return (
										<tr key={index}>
											<td>{index + 1}</td>
											<td>{`${item.firstName}  ${item.lastName}`}</td>
											<td>{item.email}</td>
											<td className="phone-col">
												<PhoneInput value={String(`+${item.countryCode}${item.phoneNumber || ''}`)} disabled />
											</td>
											<td>{item.locationName}</td>
											<td>{(item.pmsLeadSorce) ? item.pmsLeadSorce.lead_name : ''}</td>
											<td>
												{item.expectedMoveInDate &&
													moment(item.expectedMoveInDate).utc().locale('en').format('MM-DD-YYYY ')}
											</td>
											{/* <td>{item.desiredNumBedrooms.toString() === ('0' || 'Studio') ? 'Studio' : item.desiredNumBedrooms}</td> */}
											<td>
												{item.desiredNumBedrooms === '0' || item.desiredNumBedrooms === 'Studio' ? 'Studio' : item.desiredNumBedrooms}
											</td>

											<td>{item.applicationEventDate ? moment(item?.applicationEventDate).locale('en').format('MM-DD-YYYY') : ''}</td>
											<td>{item.leaseSignEventDate ? moment(item?.leaseSignEventDate).locale('en').format('MM-DD-YYYY') : ''}</td>
											<td>{item?.hasAppointment?.trim() === '1' ? 'Yes' : 'No'}</td>
										</tr>
									);
								}) : applicationEventData?.map((item: any, index: number) => {
									return (
										<tr key={index}>
											<td>{index + 1}</td>
											<td>{`${item.firstName}  ${item.lastName}`}</td>
											<td>{item.email}</td>
											<td className="phone-col">
												<PhoneInput value={String(`+${item.countryCode}${item.phoneNumber || ''}`)} disabled />
											</td>
											<td>{item.locationName}</td>
											<td>{(item.pmsLeadSorce) ? item.pmsLeadSorce.lead_name : ''}</td>
											<td>
												{item.expectedMoveInDate &&
													moment(item.expectedMoveInDate).utc().locale('en').format('MM-DD-YYYY ')}
											</td>
											{/* <td>{item.desiredNumBedrooms === ('0' || 'Studio') ? 'Studio' : item.desiredNumBedrooms}</td> */}
											<td>
												{item.desiredNumBedrooms === '0' || item.desiredNumBedrooms === 'Studio' ? 'Studio' : item.desiredNumBedrooms}
											</td>

											<td>{item.applicationEventDate ? moment(item?.applicationEventDate).locale('en').format('MM-DD-YYYY') : ''}</td>
											<td>{item.leaseSignEventDate ? moment(item?.leaseSignEventDate).locale('en').format('MM-DD-YYYY') : ''}</td>
											<td>{item?.hasAppointment?.trim() === '1' ? 'Yes' : 'No'}</td>
										</tr>
									);
								})
								}
							</tbody>
						</table>
					</div>

				</div>
			</div>
		);
	};

	const CustomModalContent = () => {
		const modalHeader = getHeaderValue(showCommonModalPopup || '');

		return (
			<div className={styles.modalContentContainer}>
				<div className={styles.modalHeader}>
					<h3>{modalHeader}</h3>

					<div className={styles.iconContainer} >
						{/* <div className={styles.downloadIcon} onClick={onDownloadData}>
							<DownloadIcon color='#fff' width='16' height='16' />
						</div> */}
						<div className={styles.closeIcon} onClick={() => {
							setShowCommonModalPopup(null)
						}}>
							<CloseIcon />
						</div>
					</div>
				</div>

				<div className={styles.modalBodyContainer}>
					<div className={`${styles.tableContainer} customScrollbar`}>
						<table className={`${styles.visitorTable} visitorListing`}>
							<thead>
								<tr>
									<th>No.</th>
									{(showCommonModalPopup && showCommonModalPopup?.toString()?.toLowerCase()?.includes('account') || (showCommonModalPopup && showCommonModalPopup?.toString()?.toLowerCase()?.includes('visitor'))) ?
										visitorHeader.slice(0, 9).map((item, index) => {
											return <th key={index}>{item.title}</th>;
										}) : TourHeader.map((item, index) => {
											return <th key={index}>{item.title}</th>;
										})
									}
								</tr>
							</thead>
							<tbody>
								{showCommonModalPopup && metricsData[showCommonModalPopup]?.map((item: any, index: number) => {
									if (showCommonModalPopup && showCommonModalPopup?.toString()?.toLowerCase()?.includes('account') || (showCommonModalPopup && showCommonModalPopup?.toString()?.toLowerCase()?.includes('visitor'))) {
										return (
											<tr key={index}>
												<td>{index + 1}</td>
												<td>{`${item?.firstName}  ${item.lastName}`}</td>
												<td>{item?.email}</td>
												<td className="phone-col">
													<PhoneInput value={String(`+${item?.countryCode}${item?.phoneNumber || ''}`)} disabled />
												</td>
												<td>{item?.locationName}</td>
												<td>{(item?.pmsLeadSorce) ? item?.pmsLeadSorce.lead_name : ''}</td>
												<td>
													{item.expectedMoveInDate &&
														moment(item.expectedMoveInDate).utc().locale('en').format('MM-DD-YYYY ')}
												</td>
												{/* <td>{item.desiredNumBedrooms?.toString() === ('0' || 'Studio') ? 'Studio' : item.desiredNumBedrooms}</td> */}
												<td>
													{item.desiredNumBedrooms === '0' || item.desiredNumBedrooms === 'Studio' ? 'Studio' : item.desiredNumBedrooms}
												</td>

												<td>{item.applicationEventDate ? moment(item?.applicationEventDate).locale('en').format('MM-DD-YYYY') : ''}</td>
												<td>{item.leaseSignEventDate ? moment(item?.leaseSignEventDate).locale('en').format('MM-DD-YYYY') : ''}</td>
											</tr>
										);
									} else {
										return (
											<tr key={index}>
												<td>{index + 1}</td>
												<td>{`${item?.firstName}  ${item.lastName}`}</td>
												<td>{item?.email}</td>
												<td className="phone-col">
													<PhoneInput value={String(`+${item?.countryCode}${item?.phoneNumber || ''}`)} disabled />
												</td>
												<td>{item?.locationName}</td>
												<td>{item?.unitName || ''}</td>
												<td>{item?.locker}</td>
												<td>{moment(`${item?.reservedDate} ${item?.start_time}`, 'YYYY-MM-DD h:mm A').format('YYYY-MM-DD h A')} - {moment(`${item?.reservedDate} ${item?.end_time}`, 'YYYY-MM-DD h:mm A').format('h A')}</td>
												<td>{item.appointmentCreationTime ? moment(item.appointmentCreationTime, 'YYYY-MM-DD h:mm A').format('YYYY-MM-DD hh:mm A') : '-'}</td>
												<td>{item?.appointmentCancellationTime ? moment(item?.appointmentCancellationTime, 'YYYY-MM-DD h:mm A').format('YYYY-MM-DD hh:mm A') : '-'}</td>
												<td>{item?.appointmentRescheduledTime ? moment(item?.appointmentRescheduledTime, 'YYYY-MM-DD h:mm A').format('YYYY-MM-DD hh:mm A') : '-'}</td>
												<td>{item?.formattedDuration || '-'}</td>
												<td>{item?.relativeStartTime || '-'}</td>
												<td>{item?.relativeEndTime || '-'}</td>
												<td>{item?.isApplyClicked ? 'Yes' : 'No'}</td>
											</tr>
										);
									}
								})
								}
							</tbody>
						</table>
					</div>

				</div>
			</div>
		);
	};



	return (
		<div className='outletConainer'>
			<p className={styles.userGreet}>
				Welcome <UserName />
			</p>
			<div className={styles.inlineHeader}>
				<p className={styles.pageTitle}>Metrics</p>
				{canReadMetrics && <div className={styles.toggleContainer}>
					<label className={styles.switch}>
						<input
							id='show-all-property-metrics'
							name="isOpen"
							onChange={(e) => {
								setShowAllPropertyMetrics(e.target.checked)
							}}
							checked={showAllPropertyMetrics ? true : false}
							type="checkbox"
						/>
						<span className={`${styles.slider} ${styles.round}`}></span>
					</label>
					<label htmlFor='show-all-property-metrics' className={styles.OpenCloseText}>Show metrics for all properties</label>
				</div>}
			</div>

			{canReadMetrics && <React.Fragment>
				<div className={styles.inlineFilter}>

					<div className={`${styles.search} ${styles.state}`}>
						<Select
							className={styles.customReactSelectDropdown}
							options={states}
							disabled={showAllPropertyMetrics}
							values={selectedState}
							keepSelectedInList
							onChange={handleChangeState}
							clearable={selectedState.length > 0}
							placeholder='States'
							onSelect={() => undefined}
							onDeselect={() => undefined}
							contentRenderer={customStateContentRenderer}
							itemRenderer={itemRenderer}
							dropdownRenderer={customStateDropdownRenderer}
						/>

						<img className={styles.searchIconImage} src={SearchIcon} alt="search-icon" />
					</div>

					<div className={`${styles.search} ${styles.cities}`}>
						<Select
							className={styles.customReactSelectDropdown}
							options={cities}
							multi
							disabled={showAllPropertyMetrics}
							values={selectedCities}
							keepSelectedInList
							onChange={handleChangeCities}
							onSelect={() => undefined}
							onDeselect={() => undefined}
							clearable={selectedCities.length > 0}
							placeholder='City'
							contentRenderer={customCityContentRenderer}
							itemRenderer={itemRenderer}
							dropdownRenderer={customCityDropdownRenderer}
						/>

						<img className={styles.searchIconImage} src={SearchIcon} alt="search-icon" />
					</div>

					<div className={styles.search}>
						<Select
							className={styles.customReactSelectDropdown}
							options={locations}
							disabled={showAllPropertyMetrics}
							multi
							values={selectedLocations}
							onSelect={() => undefined}
							onDeselect={() => undefined}
							keepSelectedInList
							onChange={handleChangeProperties}
							clearable={selectedLocations.length > 0}
							contentRenderer={customContentRenderer}
							itemRenderer={itemRenderer}
							dropdownRenderer={customDropdownRenderer}
						/>

						<img className={styles.searchIconImage} src={SearchIcon} alt="search-icon" />
					</div>

					<div className={`${styles.search}`}>
						<Select
							className={`${styles.customReactSelectDropdown} ${styles.noSearch}`}
							options={managementCompanies}
							disabled={showAllPropertyMetrics}
							multi
							name='management company'
							values={selectedCompanies}
							keepSelectedInList
							onChange={(values: ManagementCompany[]) => {
								if (values) {
									setSelectedCompanies(values)
								}
							}}
							onSelect={() => undefined}
							onDeselect={() => null}
							clearable={selectedCompanies.length > 0}
							placeholder='Management Company'
							contentRenderer={customManagementContentRenderer}
							dropdownRenderer={customCompanyDropdownRenderer}
						/>
					</div>

					<div className={`${styles.search} ${styles.noSearch}`}>
						<Select
							className={`${styles.customReactSelectDropdown} ${styles.noSearch}`}
							options={statusEnum}
							multi
							values={selectedStatus}
							keepSelectedInList
							onChange={(values: Status[]) => {
								if (values) {
									setSelectedStatus(values)
								}
							}}
							onSelect={() => undefined}
							onDeselect={() => null}
							placeholder='Status'
							clearable={selectedStatus.length > 0}
							contentRenderer={customStatusContentRenderer}
							itemRenderer={statusRenderer}
							dropdownRenderer={customStatusDropdownRenderer}
						/>
					</div>

					<div className={`${styles.datePickerWrapper} datePicker-wrapper`}>
						<DatePicker
							onChange={(e) => {
								setStartDate(e)
								if (moment(endDate).isBefore(e)) {
									setEndDate(null)
								}
							}}
							selected={startDate}
							dateFormat="MMM dd, yyyy"
							showPopperArrow={false}
							timeIntervals={30}
							placeholderText="Start Date"
							name='Start Date'
							className='custom-dateInput'
							isClearable={true}
						/>
						<img src={CalendarIcon} alt='calendar' />
					</div>

					<div className={`${styles.datePickerWrapper} datePicker-wrapper`}>
						<DatePicker
							onChange={(e) => setEndDate(e)}
							selected={endDate}
							minDate={startDate ? startDate : null}
							dateFormat="MMM dd, yyyy"
							showPopperArrow={false}
							timeIntervals={30}
							placeholderText="End Date"
							name='Start Date'
							className='custom-dateInput'
							isClearable={true}
						/>
						<img src={CalendarIcon} alt='calendar' />
					</div>

					<div className={styles.btnGroup}>
						<button
							className={styles.btnGreen}
							onClick={getMetricsData}
							disabled={(!((selectedLocations.length > 0 && endDate && startDate) || (selectedCompanies?.length && startDate && endDate)))}
						>
							Show Metrics
						</button>
						<button
							className={styles.btnReset}
							onClick={resetMetrics}
							disabled={(metricsLoading || (selectedCompanies.length === 0 && selectedState?.length === 0 && selectedCities?.length === 0 && selectedLocations?.length === 0 && selectedStatus.length === 4 && selectedCompanies.length === managementCompanies.length && (endDate == null || endDate === undefined) && (startDate === null || startDate === undefined)))}
						>
							Reset
						</button>
					</div>
				</div>
				{(metricsData?.statusCode === 200 && !metricsLoading && resultProperties?.length > 0) && (!landMarkLoading) &&
					<React.Fragment>
						<p className={styles.searchTitle}>Showing Results for <span>{showAllPropertyMetrics ? 'all properties.' : resultProperties.join(', ')}</span></p>

						<div className={styles.cardBoxContainer}>

							<div className={styles.box}
								style={{ cursor: metricsData?.totaluniqueVisitors && metricsData?.totaluniqueVisitors > 0 ? 'pointer' : 'auto' }}
								onClick={() => {
									setShowCommonModalPopup(metricsData?.totaluniqueVisitors && metricsData?.totaluniqueVisitors > 0 ?
										'uniqueVisitorsRecords' : null
									)
								}}
							>
								<p className={styles.value}>{metricsData?.totaluniqueVisitors}</p>
								<p className={styles.key}>{`Number of\nunique visitors`}</p>
							</div>


							<div className={styles.box}
								style={{ cursor: metricsData?.totalAccountsCreated && metricsData?.totalAccountsCreated > 0 ? 'pointer' : 'auto' }}
								onClick={() => {
									setShowCommonModalPopup(metricsData?.totalAccountsCreated && metricsData?.totalAccountsCreated > 0 ? 'totalAccountsRecords' : null)
								}}>
								<p className={styles.value}>{metricsData?.totalAccountsCreated}</p>
								<p className={styles.key}>{`Number of\naccounts created`}</p>
							</div>

							<div className={styles.box}
								style={{ cursor: metricsData?.totalAppointment && metricsData?.totalAppointment > 0 ? 'pointer' : 'auto' }}
								onClick={() => setShowCommonModalPopup(metricsData?.totalAppointment && metricsData?.totalAppointment > 0 ? 'data' : null)}>
								<p className={styles.value}>{metricsData?.totalAppointment}</p>
								<p className={styles.key}>{`Number of\nappointments`}</p>
							</div>

							<div className={styles.box}
								onClick={() => {
									setShowCommonModalPopup(metricsData?.totalTours && metricsData?.totalTours > 0 ? 'toursRecords' : null)
								}}
								style={{ cursor: metricsData?.totalTours && metricsData?.totalTours > 0 ? 'pointer' : 'auto' }}
							>
								<p className={styles.value}>{metricsData?.totalTours}</p>
								<p className={styles.key}>{`Number of\nof tours`}</p>
							</div>

							<div className={styles.box}
								onClick={() => {
									setShowCommonModalPopup(metricsData?.totalApplyNowClicked && metricsData?.totalApplyNowClicked ? 'applyClickedRecords' : null)
								}}
								style={{ cursor: metricsData?.totalApplyNowClicked && metricsData?.totalApplyNowClicked > 0 ? 'pointer' : 'auto' }}
							>
								<p className={styles.value}>{metricsData?.totalApplyNowClicked}</p>
								<p className={styles.key}>{`Number of times ‘Apply Now’\nclicked during the tour`}</p>
							</div>

							<div className={styles.box}>
								<p className={styles.value}>{clickEventData?.marketingLinkBeforeLogin || 0}</p>
								<p className={styles.key}>{`Number of website visits to the marketing link when a user is logged out.`}</p>
							</div>

							<div className={styles.box}>
								<p className={styles.value}>{clickEventData?.pageSeen || 0}</p>
								<p className={styles.key}>{`Number of times\n"Seen this page before? Login" is clicked`}</p>
							</div>

							<div className={styles.box}>
								<p className={styles.value}>{clickEventData?.selfGuided || 0}</p>
								<p className={styles.key}>{`Number of times\n"Not looking for a self-guided tour?" is clicked.`}</p>
							</div>

							<div className={styles.box}>
								<p className={styles.value}>{clickEventData?.stripeVerified || 0}</p>
								<p className={styles.key}>{`Number of times people click\n"Verify your documents with stripe`}</p>
							</div>

							<div className={styles.box}>
								<p className={styles.value}>{clickEventData?.marketingLinkAfterLogin || 0}</p>
								<p className={styles.key}>{`Number of website visits to\nthe marketing link when a user is logged in`}</p>
							</div>

							<div className={styles.box}
								onClick={() => {
									setShowCommonModalPopup(metricsData?.totalAppointmentCancelCount && metricsData?.totalAppointmentCancelCount > 0 ? 'appointmentCanacellationRecords' : null)
								}}
								style={{ cursor: metricsData?.totalAppointmentCancelCount && metricsData?.totalAppointmentCancelCount > 0 ? 'pointer' : 'auto' }}
							>
								<p className={styles.value}>{metricsData?.totalAppointmentCancelCount || 0}</p>
								<p className={styles.key}>{`Number of cancelled appointments`}</p>
							</div>

							<div className={styles.box}
								onClick={() => {
									setShowCommonModalPopup(metricsData?.totalAppointmentRescheduleCount && metricsData?.totalAppointmentRescheduleCount > 0 ? 'appointmentRescheduleRecords' : null)
								}}
								style={{ cursor: metricsData?.totalAppointmentRescheduleCount && metricsData?.totalAppointmentRescheduleCount > 0 ? 'pointer' : 'auto' }}
							>
								<p className={styles.value}>{metricsData?.totalAppointmentRescheduleCount || 0}</p>
								<p className={styles.key}>{`Number of rescheduled appointments`}</p>
							</div>

							<div className={styles.box}
								style={{ cursor: metricsData?.noToursAppointments && metricsData?.noToursAppointments > 0 ? 'pointer' : 'auto' }}
								onClick={() => {
									setShowCommonModalPopup(metricsData?.noToursAppointments && metricsData?.noToursAppointments > 0 ? 'appointmentWithNoTours' : null)
								}}
							>
								<p className={styles.value}>{metricsData?.noToursAppointments}</p>
								<p className={styles.key}>{`Number of\nno tours appointments`}</p>
							</div>

							<div className={styles.box}
								style={{ cursor: metricsData?.toursOnOfficeHours && metricsData?.toursOnOfficeHours > 0 ? 'pointer' : 'auto' }}
								onClick={() => {
									setShowCommonModalPopup(metricsData?.toursOnOfficeHours && metricsData?.toursOnOfficeHours > 0 ? 'toursOnOfficeHoursRecords' : null)
								}}
							>
								<p className={styles.value}>{metricsData?.toursOnOfficeHours}</p>
								<p className={styles.key}>{`Number of tours\nduring the business hours`}</p>
							</div>

							<div className={styles.box}
								style={{ cursor: metricsData?.toursOutsideOfficeHours && metricsData?.toursOutsideOfficeHours > 0 ? 'pointer' : 'auto' }}
								onClick={() => {
									setShowCommonModalPopup(metricsData?.toursOutsideOfficeHours && metricsData?.toursOutsideOfficeHours > 0 ? 'toursOutsideOfficeHoursRecords' : null)
								}}
							>
								<p className={styles.value}>{metricsData?.toursOutsideOfficeHours}</p>
								<p className={styles.key}>{`Number of tours\nafter the business hours`}</p>
							</div>

							<div className={`${styles.box} ${styles.customBox} ${applicationEventData?.length > 0 ? styles.events : ''}`}
								onClick={() => {
									if (applicationEventData?.length > 0) {
										setShowModalPopup(true);
										setSelectedEvent('application');
									}
								}}
							>
								<p className={styles.value}>{applicationEventData?.length || 0}</p>
								<p className={styles.key}>{`Number of applications`}</p>
							</div>

							<div className={`${styles.box} ${styles.customBox} ${applicationEventData?.length > 0 ? styles.events : ''}`} onClick={() => {
								if (leaseEventData?.length > 0) {
									setSelectedEvent('lease'); setShowModalPopup(true);
								}
							}}>
								<p className={styles.value}>{leaseEventData?.length || 0}</p>
								<p className={styles.key}>{`Number of lease signs`}</p>
							</div>

							<div className={`${styles.box} ${styles.customBox}`}>
								<p className={styles.value}>{totalAvailableProperties || 0}</p>
								<p className={styles.key}>{`Number of available units`}</p>
							</div>

							<div className={`${styles.box} ${styles.customBox}`}>
								<p className={styles.value}>{totalIdleProperties || 0}</p>
								<p className={styles.key}>{`Number of idle units`}</p>
							</div>
						</div>

						<div className={styles.statDataContainer}>

							<div className={styles.statBoxContainer}>
								<div className={styles.upperContainer}>
									<span className={styles.value}>{metricsData.relativeAppointmentAndCreationSet && calculateAverageHoursOfArray(metricsData.relativeAppointmentAndCreationSet)} hh:mm:ss</span>
									<span className={styles.title}>{`Average relative appointment booking time to tour start time`}</span>
								</div>

								<div className={styles.lowerContainer}>
									<div className={styles.box}>
										<span className={styles.title}>Min</span>
										<span className={styles.value}>{calculateMinOfArray(metricsData.relativeAppointmentAndCreationSet)}</span>
									</div>

									<div className={styles.box}>
										<span className={styles.title}>Q1</span>
										<span className={styles.value}>{calculateFirstQuartile(metricsData.relativeAppointmentAndCreationSet)}</span>
									</div>

									<div className={styles.box}>
										<span className={styles.title}>Med</span>
										<span className={styles.value}>{calculateMedian(metricsData.relativeAppointmentAndCreationSet)}</span>
									</div>

									<div className={styles.box}>
										<span className={styles.title}>Q3</span>
										<span className={styles.value}>{calculateThirdQuartile(metricsData.relativeAppointmentAndCreationSet)}</span>
									</div>

									<div className={styles.box}>
										<span className={styles.title}>Max</span>
										<span className={styles.value}>{calculateMaxOfArray(metricsData.relativeAppointmentAndCreationSet)}</span>
									</div>

									<div className={styles.box}>
										<span className={styles.title}>Std. Dev.</span>
										<span className={styles.value}>{calculateStandardDeviation(metricsData.relativeAppointmentAndCreationSet)}</span>
									</div>
								</div>
							</div>

							<div className={styles.statBoxContainer}>
								<div className={styles.upperContainer}>
									<span className={styles.value}>{`${metricsData.averageTourDuration} hh:mm:ss`}</span>
									<span className={styles.title}>{`Average\ntour duration`}</span>
								</div>

								<div className={styles.lowerContainer}>
									<div className={styles.box}>
										<span className={styles.title}>Min</span>
										<span className={styles.value}>{calculateMinOfArray(metricsData.tourDurationSet)}</span>
									</div>

									<div className={styles.box}>
										<span className={styles.title}>Q1</span>
										<span className={styles.value}>{calculateFirstQuartile(metricsData.tourDurationSet)}</span>
									</div>

									<div className={styles.box}>
										<span className={styles.title}>Med</span>
										<span className={styles.value}>{calculateMedian(metricsData.tourDurationSet)}</span>
									</div>

									<div className={styles.box}>
										<span className={styles.title}>Q3</span>
										<span className={styles.value}>{calculateThirdQuartile(metricsData.tourDurationSet)}</span>
									</div>

									<div className={styles.box}>
										<span className={styles.title}>Max</span>
										<span className={styles.value}>{calculateMaxOfArray(metricsData.tourDurationSet)}</span>
									</div>

									<div className={styles.box}>
										<span className={styles.title}>Std. Dev.</span>
										<span className={styles.value}>{calculateStandardDeviation(metricsData.tourDurationSet)}</span>
									</div>
								</div>
							</div>

							<div className={styles.statBoxContainer}>
								<div className={styles.upperContainer}>
									<span className={styles.value}>{`${metricsData.averageRelativeStartTime} hh:mm:ss`}</span>
									<span className={styles.title}>{`Average\nrelative tour start`}</span>
								</div>

								<div className={styles.lowerContainer}>
									<div className={styles.box}>
										<span className={styles.title}>Min</span>
										<span className={styles.value}>{calculateMinOfArray(metricsData.relativeTourStartSet)}</span>
									</div>

									<div className={styles.box}>
										<span className={styles.title}>Q1</span>
										<span className={styles.value}>{calculateFirstQuartile(metricsData.relativeTourStartSet)}</span>
									</div>

									<div className={styles.box}>
										<span className={styles.title}>Med</span>
										<span className={styles.value}>{calculateMedian(metricsData.relativeTourStartSet)}</span>
									</div>

									<div className={styles.box}>
										<span className={styles.title}>Q3</span>
										<span className={styles.value}>{calculateThirdQuartile(metricsData.relativeTourStartSet)}</span>
									</div>

									<div className={styles.box}>
										<span className={styles.title}>Max</span>
										<span className={styles.value}>{calculateMaxOfArray(metricsData.relativeTourStartSet)}</span>
									</div>

									<div className={styles.box}>
										<span className={styles.title}>Std. Dev.</span>
										<span className={styles.value}>{calculateStandardDeviation(metricsData.relativeTourStartSet)}</span>
									</div>
								</div>
							</div>

							<div className={styles.statBoxContainer}>
								<div className={styles.upperContainer}>
									<span className={styles.value}>{`${metricsData.averageRelativeEndTime} hh:mm:ss`}</span>
									<span className={styles.title}>{`Average\nrelative tour end`}</span>
								</div>

								<div className={styles.lowerContainer}>
									<div className={styles.box}>
										<span className={styles.title}>Min</span>
										<span className={styles.value}>{calculateMinOfArray(metricsData.relativeTourEndSet)}</span>
									</div>

									<div className={styles.box}>
										<span className={styles.title}>Q1</span>
										<span className={styles.value}>{calculateFirstQuartile(metricsData.relativeTourEndSet)}</span>
									</div>

									<div className={styles.box}>
										<span className={styles.title}>Med</span>
										<span className={styles.value}>{calculateMedian(metricsData.relativeTourEndSet)}</span>
									</div>

									<div className={styles.box}>
										<span className={styles.title}>Q3</span>
										<span className={styles.value}>{calculateThirdQuartile(metricsData.relativeTourEndSet)}</span>
									</div>

									<div className={styles.box}>
										<span className={styles.title}>Max</span>
										<span className={styles.value}>{calculateMaxOfArray(metricsData.relativeTourEndSet)}</span>
									</div>

									<div className={styles.box}>
										<span className={styles.title}>Std. Dev.</span>
										<span className={styles.value}>{calculateStandardDeviation(metricsData.relativeTourEndSet)}</span>
									</div>
								</div>
							</div>

							<div className={styles.statBoxContainer}>
								<div className={styles.upperContainer}>
									<span className={styles.value}>{calculateAverageOfArray(metricsData.appointmentPerVisitorSet, 'average')}</span>
									<span className={styles.title}>{`Average number of Appointments made\nper visitor`}</span>
								</div>

								<div className={styles.lowerContainer}>
									<div className={styles.box}>
										<span className={styles.title}>Min</span>
										<span className={styles.value}>{calculateMinOfArray(metricsData.appointmentPerVisitorSet, 'average')}</span>
									</div>

									<div className={styles.box}>
										<span className={styles.title}>Q1</span>
										<span className={styles.value}>{calculateFirstQuartile(metricsData.appointmentPerVisitorSet, 'average')}</span>
									</div>

									<div className={styles.box}>
										<span className={styles.title}>Med</span>
										<span className={styles.value}>{calculateMedian(metricsData.appointmentPerVisitorSet, 'average')}</span>
									</div>

									<div className={styles.box}>
										<span className={styles.title}>Q3</span>
										<span className={styles.value}>{calculateThirdQuartile(metricsData.appointmentPerVisitorSet, 'average')}</span>
									</div>

									<div className={styles.box}>
										<span className={styles.title}>Max</span>
										<span className={styles.value}>{calculateMaxOfArray(metricsData.appointmentPerVisitorSet, 'average')}</span>
									</div>

									<div className={styles.box}>
										<span className={styles.title}>Std. Dev.</span>
										<span className={styles.value}>{calculateStandardDeviation(metricsData.appointmentPerVisitorSet, 'average')}</span>
									</div>
								</div>
							</div>

							<div className={styles.statBoxContainer}>
								<div className={styles.upperContainer}>
									<span className={styles.value}>{metricsData.averageOfTourBySingleVisitor}</span>
									<span className={styles.title}>{`Average number of tours\nper visitor`}</span>
								</div>

								<div className={styles.lowerContainer}>
									<div className={styles.box}>
										<span className={styles.title}>Min</span>
										<span className={styles.value}>{calculateMinOfArray(metricsData.perUserTourSet, 'average')}</span>
									</div>

									<div className={styles.box}>
										<span className={styles.title}>Q1</span>
										<span className={styles.value}>{calculateFirstQuartile(metricsData.perUserTourSet, 'average')}</span>
									</div>

									<div className={styles.box}>
										<span className={styles.title}>Med</span>
										<span className={styles.value}>{calculateMedian(metricsData.perUserTourSet, 'average')}</span>
									</div>

									<div className={styles.box}>
										<span className={styles.title}>Q3</span>
										<span className={styles.value}>{calculateThirdQuartile(metricsData.perUserTourSet, 'average')}</span>
									</div>

									<div className={styles.box}>
										<span className={styles.title}>Max</span>
										<span className={styles.value}>{calculateMaxOfArray(metricsData.perUserTourSet, 'average')}</span>
									</div>

									<div className={styles.box}>
										<span className={styles.title}>Std. Dev.</span>
										<span className={styles.value}>{calculateStandardDeviation(metricsData.perUserTourSet, 'average')}</span>
									</div>
								</div>
							</div>

							<div className={styles.statBoxContainer}>
								<div className={styles.upperContainer}>
									<span className={styles.value}>{calculateAverageOfArray(metricsData.totalUniqueUnitsTouredPerVisitor, 'average')}</span>
									<span className={styles.title}>{`Average number of unique units\ntoured per visitor`}</span>
								</div>

								<div className={styles.lowerContainer}>
									<div className={styles.box}>
										<span className={styles.title}>Min</span>
										<span className={styles.value}>{calculateMinOfArray(metricsData.totalUniqueUnitsTouredPerVisitor, 'average')}</span>
									</div>

									<div className={styles.box}>
										<span className={styles.title}>Q1</span>
										<span className={styles.value}>{calculateFirstQuartile(metricsData.totalUniqueUnitsTouredPerVisitor, 'average')}</span>
									</div>

									<div className={styles.box}>
										<span className={styles.title}>Med</span>
										<span className={styles.value}>{calculateMedian(metricsData.totalUniqueUnitsTouredPerVisitor, 'average')}</span>
									</div>

									<div className={styles.box}>
										<span className={styles.title}>Q3</span>
										<span className={styles.value}>{calculateThirdQuartile(metricsData.totalUniqueUnitsTouredPerVisitor, 'average')}</span>
									</div>

									<div className={styles.box}>
										<span className={styles.title}>Max</span>
										<span className={styles.value}>{calculateMaxOfArray(metricsData.totalUniqueUnitsTouredPerVisitor, 'average')}</span>
									</div>

									<div className={styles.box}>
										<span className={styles.title}>Std. Dev.</span>
										<span className={styles.value}>{calculateStandardDeviation(metricsData.totalUniqueUnitsTouredPerVisitor, 'average')}</span>
									</div>
								</div>
							</div>

							<div className={styles.statBoxContainer}>
								<div className={styles.upperContainer}>
									<span className={styles.value}>{calculateAverageOfArray(metricsData.totalUniqueLocationsTouredPerVisitor, 'average')}</span>
									<span className={styles.title}>{`Average number of unique\nproperties toured per visitor`}</span>
								</div>

								<div className={styles.lowerContainer}>
									<div className={styles.box}>
										<span className={styles.title}>Min</span>
										<span className={styles.value}>{calculateMinOfArray(metricsData.totalUniqueLocationsTouredPerVisitor, 'average')}</span>
									</div>

									<div className={styles.box}>
										<span className={styles.title}>Q1</span>
										<span className={styles.value}>{calculateFirstQuartile(metricsData.totalUniqueLocationsTouredPerVisitor, 'average')}</span>
									</div>

									<div className={styles.box}>
										<span className={styles.title}>Med</span>
										<span className={styles.value}>{calculateMedian(metricsData.totalUniqueLocationsTouredPerVisitor, 'average')}</span>
									</div>

									<div className={styles.box}>
										<span className={styles.title}>Q3</span>
										<span className={styles.value}>{calculateThirdQuartile(metricsData.totalUniqueLocationsTouredPerVisitor, 'average')}</span>
									</div>

									<div className={styles.box}>
										<span className={styles.title}>Max</span>
										<span className={styles.value}>{calculateMaxOfArray(metricsData.totalUniqueLocationsTouredPerVisitor, 'average')}</span>
									</div>

									<div className={styles.box}>
										<span className={styles.title}>Std. Dev.</span>
										<span className={styles.value}>{calculateStandardDeviation(metricsData.totalUniqueLocationsTouredPerVisitor, 'average')}</span>
									</div>
								</div>
							</div>

						</div>

						{!!metricsData?.data?.length && <button className={styles.exportBtnGreen} onClick={exportToExcel}>Export to Excel</button>}

						<div className={styles.tableContainer}>
							<table >
								<thead>
									<tr>
										{tableHeader?.map((head: { title: string }, index: number) => {
											return <th key={index}>{head.title}</th>
										})}
									</tr>
								</thead>

								<tbody>
									{
										metricsData?.data?.length ? metricsData?.data?.map((appointment: MetricsData, index: number) => {
											return <tr key={index}>
												<td>{appointment?.email}</td>
												<td>{appointment?.locationName}</td>
												<td>{appointment?.unitName}</td>
												<td>{appointment?.managementCompany || '-'}</td>
												<td className={styles.centerLocker}>{appointment?.locker}</td>
												<td>{(appointment?.userCreationTime) ? moment.utc(appointment?.userCreationTime).tz(appointment?.timeZone).locale('en').format('YYYY-MM-DD hh:mm A') : ''}</td>
												<td>{appointment.appointmentCreationTime ? moment(appointment.appointmentCreationTime, 'YYYY-MM-DD h:mm A').format('YYYY-MM-DD hh:mm A') : '-'}</td>
												<td>{moment(`${appointment.reservedDate} ${appointment.start_time}`, 'YYYY-MM-DD h:mm A').format('YYYY-MM-DD h A')} - {moment(`${appointment.reservedDate} ${appointment.end_time}`, 'YYYY-MM-DD h:mm A').format('h A')}</td>
												<td>{appointment.appointmentCancellationTime ? moment(appointment.appointmentCancellationTime, 'YYYY-MM-DD h:mm A').format('YYYY-MM-DD hh:mm A') : '-'}</td>
												<td>{appointment.appointmentRescheduledTime ? moment(appointment.appointmentRescheduledTime, 'YYYY-MM-DD h:mm A').format('YYYY-MM-DD hh:mm A') : '-'}</td>
												<td>{appointment?.formattedDuration || '-'}</td>
												<td>{appointment?.relativeStartTime || '-'}</td>
												<td>{appointment?.relativeEndTime || '-'}</td>
												<td>{appointment?.isApplyClicked ? 'Yes' : 'No'}</td>
											</tr>

										})
											:
											<tr>
												<td colSpan={13} style={{ textAlign: 'center' }}>{'No Data Found'}</td>
											</tr>
									}
								</tbody>
							</table>
						</div>
					</React.Fragment>
				}
				{
					(metricsLoading || landMarkLoading || permissionLoading) && <div className={styles.loadingContainer}>
						<Loader />
					</div>
				}
				{
					!!showModalPopup && (
						<CustModal className='custom-event-modal' open={showModalPopup} setOpen={setShowModalPopup} bodyData={<ModalContent />} onCloseModal={onCloseModal} />
					)
				}

				{
					!!showCommonModalPopup && (
						<CustModal className='custom-event-modal' open={showCommonModalPopup ? true : false} bodyData={<CustomModalContent />} onCloseModal={onCustomCloseModal} />
					)
				}
			</React.Fragment>}
		</div >
	)
}

export default metrics